import React, { useState } from 'react';
import "./styles.css";
import { ToggleCustom } from '../../../components/FormComponents';
import { RelevantIcon } from '../../../components/oro-module/RelevantIcon';
import { handlePageChange } from '../../../components/oro-module/ajaxdata';


const HelpSuggestion = ({ title, desc, fastpath, current }) => {
  return (
    <div className="help-suggestion-container" onClick={() => handlePageChange({ item: { fastpath, label: fastpath }, current })}>
      <div className="help-suggestion-title">{title}</div>
      <div className="help-suggestion-desc">{desc}</div>
    </div>
  )
}

const Help = ({ props }) => {

  let [helpDisplayed, sethelpDisplayed] = useState([]);
  let [typed, settyped] = useState("");

  let {
    themecolor
  } = props.parentState;

  const handleSuggestion = (e) => {
    let typ = e.target.value;
    settyped(typ);

    const helpSuggestions = [{ title: "Customize Look", desc: "How to customize the look and feel of your theme as well as your custom shortcuts.", fastpath: "" }, { title: "Customer Registration", desc: "Register new customer from ms101. You can use mobile app to scan documents. Show more...", fastpath: "customers" }, { title: "Issue new ATM Card", desc: "Get the customers request on paper form or from customers app, and go to ms134. Show more...", fastpath: "" }, { title: "Activate Internet Banking", desc: "Take consent from the customer on form 28 and submit request from ms128. Show more...", fastpath: "" }, { title: "Products", desc: "product parameters.", fastpath: "products" }, { title: "General Ledgers", desc: "GL parameters.", fastpath: "gls" }];
    if (typ.length > 3) {
      let matched = [];
      helpSuggestions.map(({ title, desc, fastpath }) => {
        if (title.toLocaleLowerCase().indexOf(typ) != -1 || desc.toLocaleLowerCase().indexOf(typ) != -1) {
          matched.push({ title, desc, fastpath });
        }
      })
      sethelpDisplayed(matched);
    }
  }

  const handleSearch = (typed) => {
    console.log("handlearch")

  }



  return (
    <div className="row" style={{ marginRight: 0, paddingLeft: 16 }}>
      <div className="col-12 help-box-container">
        <div style={{ paddingTop: 5, width: "90%" }} className="searchinput-container">
          <input
            autoComplete="off"
            type="text"
            id="help-textbox"
            className={` ${themecolor}-fastpath`}
            name="search"
            placeholder="Type your query . . ."
            onChange={handleSuggestion}
            value={typed}
          // onKeyPress={handleSearch}
          // onFocus={handleSearch}
          // onBlur={handleSearch}
          />
        </div>
        {helpDisplayed.map(({ title, desc, fastpath }, idx) =>
          <HelpSuggestion key={idx} title={title} current={{ props }} desc={desc} fastpath={fastpath} />
        )}
      </div>
    </div>
  )
}


const TopRightMenus = (props) => {
  let { historyTableParams, LocalVars, TopRightMenuStatus, remoteip } = props.parentState;
  let lgs = props.liftGlobalState;

  let ibosip = "http://192.168.40.129:20000";
  let shieldurl = "https://192.168.40.129:8000/index-shield.html";
  const clickButton = (id) => {
    let elem = document.getElementById(id);
    if (elem) {
      elem.click();
    }
  }

  const handlePerPage = (nv) => {
    historyTableParams.perPage = parseInt(nv);
    lgs({ name: 'historyTableParams' }, historyTableParams);
    setTimeout(() => clickButton('set-page-size'), 10)
  }

  const handleTotalRecords = (nv) => {
    historyTableParams.limitresults = parseInt(nv);
    lgs({ name: 'historyTableParams' }, historyTableParams);
  }

  const toggleLargeText = () => {
    LocalVars.compressed = !LocalVars.compressed;
    lgs({ name: 'LocalVars' }, LocalVars);
  }

  const toggleAdvanceSearch = () => {
    LocalVars.advsearch = !LocalVars.advsearch;
    lgs({ name: 'LocalVars' }, LocalVars);
  }

  const toggleFullScreenReports = () => {
    LocalVars.fullscreenreport = !LocalVars.fullscreenreport;
    lgs({ name: 'LocalVars' }, LocalVars);
  }

  return (
    <div>
      {TopRightMenuStatus &&
        <div id="top-right-menu">
          <div className="col-sm-12" style={{ padding: 2 }}>
            <div style={{ backgroundColor: "#E8F0FE", color: "gray", fontSize: 12, height: 20, textAlign: "center", borderRadius: 5 }}>
              {TopRightMenuStatus == 'help-menu' && <span>Help</span>}
              {TopRightMenuStatus == 'language-menu' && <span>Language</span>}
              {TopRightMenuStatus == 'settings-menu' && <span>Settings</span>}
            </div>
          </div>

          {TopRightMenuStatus == 'help-menu' &&
            <Help props={props} />
          }

          {TopRightMenuStatus == 'language-menu' &&
            <div>language</div>
          }


          {TopRightMenuStatus == 'settings-menu' &&
            <span>
              <div className="row settings-row">
                <div className="col-sm-7" style={{ fontSize: 15 }}>Records Per Page</div>
                <div className="col-sm-5" >
                  <select
                    className="form-control form-control-sm "
                    value={
                      historyTableParams.perPage
                    }
                    onChange={(e) => handlePerPage(e.target.value)}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>

              <div className="row settings-row">
                <div className="col-sm-7" style={{ fontSize: 15 }}>Fetch Records</div>
                <div className="col-sm-5">
                  <select
                    className="form-control form-control-sm "
                    value={
                      historyTableParams.limitresults
                    }
                    onChange={(e) => handleTotalRecords(e.target.value)}
                  >
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="99999">ALL</option>
                  </select>
                </div>
              </div>


              <div className="row settings-row">
                <div className="col-sm-7" style={{ fontSize: 15 }}>Large text</div>
                <div className="col-sm-5">
                  <ToggleCustom isChecked={LocalVars.compressed} display={LocalVars.compressed ? "Large" : "Small"} setChecked={(toggleLargeText)} />
                </div>
              </div>

              <div className="row settings-row">
                <div className="col-sm-7" style={{ fontSize: 15 }}>Full Screen Reports</div>
                <div className="col-sm-5">
                  <ToggleCustom isChecked={LocalVars.fullscreenreport} display={LocalVars.fullscreenreport ? "Full" : "Compact"} setChecked={(toggleFullScreenReports)} />
                </div>
              </div>

              <div className="row settings-row">
                <div className="col-sm-7" style={{ fontSize: 15 }}>Readability Mode</div>
                <div className="col-sm-5">
                  <ToggleCustom isChecked={LocalVars.fullscreenreport} display={LocalVars.fullscreenreport ? "Full" : "Compact"} setChecked={(toggleFullScreenReports)} />
                </div>
              </div>

              <div className="row settings-row">
                <div className="col-sm-7" style={{ fontSize: 15 }}>Advance Search</div>
                <div className="col-sm-5">
                  <ToggleCustom isChecked={LocalVars.advsearch} display={LocalVars.advsearch ? "Advance" : "Simple "} setChecked={(toggleAdvanceSearch)} />
                </div>
              </div>
              <div className="row settings-row">
                <div className="col-sm-12 hand underline" onClick={() => window.open(`${ibosip}`)}>AI Monitoring
                  &nbsp;<RelevantIcon style={{ fontSize: 15, color: '#5F6368' }} icon="new-tab" />
                </div>
              </div>

              <div className="row settings-row">
                <div className="col-sm-12 hand underline" onClick={() => window.open(`${shieldurl}`)}>Network
                  &nbsp;<RelevantIcon style={{ fontSize: 15, color: '#5F6368' }} icon="new-tab" />
                </div>
              </div>
            </span>
          }
        </div>
      }
    </div>
  );
}

export default TopRightMenus;